import React from "react";
import { HashLink } from "react-router-hash-link";
import "./backToTop.scss";

export default function BackToTop({
  to = "#terms-top",
  label = "Back to top",
  scrollWithOffset,
  additionalOffset = 0,
  className = "terms_backToTopPill",
  wrapClassName = "terms_backToTopWrap",
}) {
  return (
    <div className={wrapClassName}>
      <HashLink
        smooth
        replace
        to={to}
        className={className}
        scroll={(el) =>
          typeof scrollWithOffset === "function"
            ? scrollWithOffset(el, additionalOffset)
            : el.scrollIntoView({ behavior: "smooth", block: "start" })
        }
      >
        <span className="terms_backToTopIcon" aria-hidden="true">
          ↑
        </span>
        <span className="terms_backToTopLabel">{label}</span>
      </HashLink>
    </div>
  );
}
